<template>
  <div class="batch-item">
    <div>
      {{ getStatusText }}
      <i class="el-icon-check" v-if="item.status === 'success'"></i>
    </div>
    <div v-if="item.error" class="batch-item--error">
      {{ item.error && item.error.desc }}
    </div>
    <div>
      <a v-for="cardItem in item.cards" :key="cardItem.card" :href="`/#/cards/${cardType}s/${cardItem.card}`">{{ $tf('common.card') }} {{ cardItem.card }}<br /></a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'batch-item',
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    cardType: {
      type: String,
      default: 'human'
    }
  },
  computed: {
    getStatusText() {
      switch (this.item.status) {
        case 'success':
          return '';
        case 'card':
          return this.$tf('common.in_progress');
        case 'error':
          return this.$tf('common.error');
        default:
          return this.$tf('common.in_queue');
      }
    }
  }
};
</script>

<style>
.batch-item--error {
  color: #999;
  font-size: 0.9rem;
}
</style>
